export enum VS_LAUNCH_CALLER {
  IDLE_TIMEOUT = 'IDLE_TIMEOUT',
  ADD_TO_CART = 'ADD_TO_CART',
  GET_A_QUOTE = 'GET_A_QUOTE',
  NON_BUYABLE_PARTS = 'NON_BUYABLE_PARTS',
  DELETE_BUY_CART = 'DELETE_BUY_CART',
  CRD_INPUT_MODAL = 'CRD_INPUT_MODAL',
  DELIVERY_GROUP = 'DELIVERY_GROUP',
  COMPLETE_ORDER = 'COMPLETE_ORDER',
  MERGE_CART_ITEM = 'MERGE_CART_ITEM',
  MIN_ORDER_CONFIRMATION = 'MIN_ORDER_CONFIRMATION',
  NON_SELLABLE = 'NON_SELLABLE',
  NON_SELLABLE_QUOTE = 'NON_SELLABLE_QUOTE',
  VIEW_INVENTORY = 'VIEW_INVENTORY',
  ORDER_REVIEW = 'ORDER_REVIEW',
  CREATE_SAVED_CART = 'CREATE_SAVED_CART',
  DELETE_SAVED_CART = 'DELETE_SAVED_CART',
  EXTEND_CART_EXPIRY = 'EXTEND_CART_EXPIRY',
  RESTORE_SAVED_CART = 'RESTORE_SAVED_CART',
  RESTORE_SAVED_QUOTE_CART = 'RESTORE_SAVED_QUOTE_CART',
  BULK_ORDER = 'BULK_ORDER',
  BULK_ORDER_CART = 'BULK_ORDER_CART',
  OUTAGE_NOTIFICATION = 'OUTAGE_NOTIFICATION',
  MY_FAVOURITES = 'MY_FAVOURITES',
  SINGLE_QUOTE = 'SINGLE_QUOTE',
  MY_FAVOURITES_PDP = 'MY_FAVOURITES_PDP',
  DELETE_QUOTE_CART = 'DELETE_QUOTE_CART',
  FASTTRACK_QUOTE = 'FASTTRACK_QUOTE',
  INVENTORY_AVAILABILITY = 'INVENTORY_AVAILABILITY',
  SAVED_QUOTE_CART = 'SAVED_QUOTE_CART',
  EDITED_QUOTE = 'EDITED_QUOTE',
  QUOTE_EDIT = 'QUOTE_EDIT',
  ACCEPT_QUOTE = 'ACCEPT_QUOTE',
  REJECT_QUOTE = 'REJECT_QUOTE',
  AUTOFILL_NO = 'AUTOFILL_NO',
  WARNING_DIALOG = 'WARNING_DIALOG',
  ADD_BOM_TO_CART = 'ADD_BOM_TO_CART',
  ADD_BOM_TO_QUOTE_CART = 'ADD_BOM_TO_QUOTE_CART',
  MERGE_QUOTE_EDIT = 'MERGE_QUOTE_EDIT',
  MERGE_QUOTE = 'MERGE_QUOTE',
  CART_MODAL = 'CART_MODAL',
  QUOTE_MODAL = 'QUOTE_MODAL',
  MERGE_CHEKOUT_CART_ITEMS = 'MERGE_CHEKOUT_CART_ITEMS',
}

export interface DialogResponse {
  type: VS_LAUNCH_CALLER
  data?: any
  reason: string
}
